import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Settings, Table } from 'lucide-react';
import { AdminTabs } from '../../../ui';
import { DataSourceSettings } from './DataSourceSettings';
import { DataSourceViewer } from './DataSourceViewer';

type TabId = 'settings' | 'viewer';

const tabs = [
  { id: 'settings' as TabId, label: 'Configurações', icon: <Settings className="w-4 h-4" /> },
  { id: 'viewer' as TabId, label: 'Visualizador de Dados', icon: <Table className="w-4 h-4" /> },
];

export const DataSourceDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabId>('settings');

  return (
    <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-6">
      {/* Header */}
      <div className="mb-6">
        <button
          onClick={() => navigate('/admin/datasources')}
          className="flex items-center gap-2 text-[#888888] hover:text-white transition-colors mb-4"
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar para Data Sources
        </button>
      </div>

      {/* Tabs */}
      <div className="mb-6">
        <AdminTabs
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={(tabId) => setActiveTab(tabId as TabId)}
        />
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'settings' && <DataSourceSettings id={id} />}
        {activeTab === 'viewer' && <DataSourceViewer id={id} />}
      </div>
    </div>
  );
};

export default DataSourceDetail;
